var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownToLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.53655 11.1098C6.14956 10.7158 6.15527 10.0826 6.54929 9.6956C6.94332 9.30865 7.57646 9.31435 7.96345 9.7084L11.25 13.0547V4.5C11.25 3.94772 11.6977 3.5 12.25 3.5C12.8023 3.5 13.25 3.94772 13.25 4.5V13.0547L16.5366 9.7084C16.9235 9.31435 17.5567 9.30865 17.9507 9.6956C18.3447 10.0826 18.3504 10.7158 17.9634 11.1098L12.9634 16.2007C12.7754 16.3922 12.5183 16.5 12.25 16.5C11.9817 16.5 11.7246 16.3922 11.5366 16.2007L6.53655 11.1098ZM6.25 19.5C5.69772 19.5 5.25 19.9477 5.25 20.5C5.25 21.0523 5.69772 21.5 6.25 21.5H18.25C18.8023 21.5 19.25 21.0523 19.25 20.5C19.25 19.9477 18.8023 19.5 18.25 19.5H6.25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownToLine);
export default __webpack_public_path__ + "static/media/arrow_down_to_line.39f198663409ba1d41b2c24399001723.svg";
export { ForwardRef as ReactComponent };